import React from 'react';
import { GlobeIcon, ShoppingBasketIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const reasons = [{
  icon: ShoppingBasketIcon,
  title: 'Alimentos disponibles',
  text: 'Verduras, proteínas y carbohidratos que conseguís en toda LATAM y España.'
}, {
  icon: GlobeIcon,
  title: 'Estructuras universales',
  text: 'Los principios y protocolos funcionan aunque tu supermercado sea distinto.'
}];
export function WhyGlobal() {
  return <section className="w-full bg-white" aria-labelledby="global-title" style={{
    paddingTop: "20px",
    paddingBottom: "20px"
  }} data-id="element-230" data-mp="36lgyz1stafsi">
      <div className="mx-auto max-w-6xl px-6 text-center" data-id="element-231" data-mp="3gbjxfhipcly8">
        <div className="rounded-3xl bg-mint-800 px-8 py-12 sm:px-14 sm:py-16" data-id="element-232" data-mp="3gc24l96wkkkx">
          <Reveal className="mx-auto max-w-2xl" data-id="element-233" data-mp="3l9ll6fr2p9g1">
            <h2 id="global-title" className="font-display text-3xl leading-tight text-white sm:text-4xl" data-id="element-234" data-mp="3lchjw6aqw25j">
              ¿Por qué funciona en cualquier pais ?
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-mint-100" data-id="element-235" data-mp="3ubkz2z6sjxer">
              Trabaje para que este material funcione dondequiera que estés.
            </p>
          </Reveal>

          <dl className="mx-auto mt-12 grid max-w-3xl gap-10 sm:grid-cols-2" data-id="element-236" data-mp="283jx9waa0sjk">
            {reasons.map((reason, index) => <Reveal key={reason.title} delay={index * 0.05} data-id="element-237" data-mp="235iivonsphef" data-mpi={index}>
                <dt className="flex items-center justify-center gap-3 text-white" data-id="element-238" data-mp="1y6yxbpd467ml">
                  <reason.icon className="h-5 w-5 text-mint-300" aria-hidden="true" data-id="element-239" data-mp="2vuh1snzqsnks" />
                  <span className="font-display text-xl" data-id="element-240" data-mp="2quus2oj4hpgq">{reason.title}</span>
                </dt>
                <dd className="mt-3 text-[15px] leading-relaxed text-mint-100" data-id="element-241" data-mp="2m44j71bhn4ha">
                  {reason.text}
                </dd>
              </Reveal>)}
          </dl>
        </div>
      </div>
    </section>;
}